import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { fromEvent, of } from 'rxjs';
import { combineLatest, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, mapTo, merge, startWith, switchMap, tap } from 'rxjs/operators';
import { ItemsService } from '../items/items.service';
import { Item } from '../models/item';


@Component({
   selector: 'app-test',
   templateUrl: './test.component.html',
   styleUrls: ['./test.component.css'],
})
export class TestComponent {

}
